import React, { forwardRef, useEffect } from "react";
import { useTranslation } from "react-i18next";

const formatDate = (date) =>
  new Date(date).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

const styles = {
  wrapper: (direction) => ({
    fontFamily: "Arial, sans-serif",
    padding: 15,
    boxSizing: "border-box",
    direction,
  }),
  hr: {
    width: "100%",
    height: 1,
    background: "#9fb0cc",
    margin: "30px 0",
  },
  labelValueRow: {
    marginBottom: 10,
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid #b1c7b7",
  },
};

const PrintMedicinePayment = forwardRef(({ data }, ref) => {
  const { t } = useTranslation();
  const direction = localStorage.getItem("direction");

  useEffect(() => {
    const printCSS = `
      @media print {
        @page { size:A4; margin:0; }
        html, body {
          width: 210mm; height: 297mm; margin: 0!important; padding: 0!important;
          background: #fff!important;
        }
        body * { visibility: hidden; }
        #printable, #printable * { visibility: visible; }
        #printable { position: absolute; inset: 0; width: 100%; margin: 0; padding: 0; }
      }
    `;
    const style = Object.assign(document.createElement("style"), {
      textContent: printCSS,
    });
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <div ref={ref} id="printable" style={styles.wrapper(direction)}>
      <div style={{ display: "flex", justifyContent: "center", marginBottom: 15 }}>
        <img
          src={`${process.env.REACT_APP_MEDIA_URL}/images/logo/logo.png`}
          alt="Logo"
          style={{ width: 150, height: 150 }}
        />
      </div>

      <div style={{ marginBottom: 10 }}>
        <p style={{ margin: 0 }}>
          {t("finance.paymentReceipt","Payment Receipt")}:{" "}
          <strong style={{ marginLeft: 8 }}>{data?.id}</strong>
        </p>
        <p style={{ margin: 0 }}>
          {t("finance.paymentDate")}:{" "}
          <strong style={{ marginLeft: 8 }}>{formatDate(data?.date)}</strong>
        </p>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 15,
          height: 50,
        }}
      >
        <div style={{ flex: 1, height: 1, background: "#000" }} />
        <p style={{ margin: "0 10px", textTransform: "capitalize" }}>
          {t("finance.medicinePaymentReceipt","Medicine Payment Receipt")}
        </p>
        <div style={{ flex: 1, height: 1, background: "#000" }} />
      </div>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          gap: 10,
          marginBottom: 15,
        }}
      >
        <span>
          {t("finance.company")}: <strong>{data.medicine_company_display}</strong>
        </span>
        <span>
          {t("finance.invoiceNumber")}: <strong>{data.invoice_number || "-"}</strong>
        </span>
        <span>
          {t("finance.date")}: <strong>{formatDate(data.date)}</strong>
        </span>
      </div>

      <div style={styles.hr} />

      <div style={{ fontSize: 14, lineHeight: 1.6, color: "#333" }}>
        <div style={styles.labelValueRow}>
          <strong>{t("finance.amountPaid")}:</strong>
          <span>؋ {data.amount?.toLocaleString()}</span>
        </div>
        <div style={styles.labelValueRow}>
          <strong>{t("finance.paymentMethod","Payment Method")}:</strong>
          <span>{data.payment_method || t("finance.cash","Cash")}</span>
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "center", height: 300 }}></div>


      <div style={{ textAlign: "center", color: "#555", marginTop: 20 }}>
        <p style={{ margin: 8 }}>{t("print.thanks")}</p>
        <p style={{ margin: 8 }}>{t("print.getWellSoon")}</p>
        <p style={{ margin: 8, fontSize: 12 }}>{t("print.cosmos")}</p>
        <h6 style={{ margin: 0, fontWeight: "bold" }}>
          {t("print.turkishClinic")}
        </h6>
        <p style={{ margin: 4, fontSize: 12 }}>
          {t("print.phone")}: {t("print.phoneNumber")}
        </p>
        <p style={{ margin: 4, fontSize: 12 }}>{t("print.address")}</p>
      </div>
    </div>
  );
});

export default PrintMedicinePayment;